import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardMedia from "@mui/material/CardMedia";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import CheckIcon from "@mui/icons-material/Check";
import ExtrasDialog from "./ExtrasDialog";
import { getData, postData } from "../api/AuthenticatedApiCaller";
import { ExtrasApi } from "../api/AdminApi";
import { ExtrasAddDialog } from "./ExtrasAddDialog";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { baseURLWithoutPort } from "../../../client/api/GardenoApi";

export default function InsuranceView() {
  const [extras, setExtras] = useState(null);
  const [update, setUpdate] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editedExtra, setEditedExtra] = useState(null);

  async function fetchData() {
    const [data, error] = await getData(ExtrasApi.getAll);
    if (error) {
      // Handle the error
    } else {
      setExtras(data);
    }
  }

  async function setActivity(id, isActive) {
    const [data, error] = await postData(
      ExtrasApi.setActivity + "?id=" + id + "&isActive=" + isActive
    );
    if (error) {
      // Handle the error
    } else {
      setUpdate(true);
    }
  }

  useEffect(() => {
    if (extras === null || update) {
      fetchData();
      setUpdate(false);
    }
  }, [update]);

  return (
    <Box>
      <Button
        onClick={() => {
          setIsDialogOpen(true);
          setEditedExtra(null);
        }}
        variant="outlined"
      >
        Create Extra
      </Button>

      {isDialogOpen === true && (
        <ExtrasAddDialog
          open={isDialogOpen}
          extra={editedExtra}
          save={() => {
            setIsDialogOpen(false);
            setUpdate(true);
          }}
          cancel={() => setIsDialogOpen(false)}
        />
      )}

      <Table sx={{ minWidth: 650 }} aria-label="extra table">
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Price Per Day</TableCell>
            <TableCell>Image</TableCell>
            <TableCell>Active</TableCell>
            <TableCell>Edit</TableCell>
          </TableRow>
        </TableHead>
        {extras !== null && (
          <TableBody>
            {extras.data.map((extra) => {
              return (
                <TableRow>
                  <TableCell>{extra["id"]}</TableCell>
                  <TableCell>{extra["title"]}</TableCell>
                  <TableCell>{extra["pricePerDay"]}</TableCell>

                  <TableCell>
                    <Card sx={{ maxWidth: 100, maxHeight: 100 }}>
                      <CardMedia
                        component="img"
                        image={baseURLWithoutPort + extra["imageUrl"]}
                      />
                    </Card>
                  </TableCell>
                  {extra.active !== true ? (
                    <TableCell>
                      <IconButton>
                        <DoNotDisturbIcon
                          onClick={() => setActivity(extra.id, true)}
                        />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>
                      <IconButton>
                        <CheckIcon
                          onClick={() => setActivity(extra.id, false)}
                        />
                      </IconButton>
                    </TableCell>
                  )}

                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedExtra(extra);
                          setIsDialogOpen(true);
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>

      {/* <ExtrasDialog
        extra={editedExtra}
        open={isDialogOpen}
        refresh={forceUpdate}
        close={() => {
          setEditedExtra(null);
          setIsDialogOpen(false);
        }}
      /> */}
    </Box>
  );
}
